import JsonConverter from "../../api/helper/JsonConverter";
import {none, option, Option} from "ts-option";
import * as moment from "moment";
import {MerchantApiDto} from "../../api/model/rest";

/**
 * Merchant model.
 */
export default class Merchant {
	/**
	 * String using to search.
	 */
	public readonly searchString: string;

	constructor(public readonly id: string,
		public readonly name: string,
		public readonly branchesLastUpdateDate: Option<moment.Moment>) {
		this.searchString = `${name}`.toLowerCase()
	}

	static fromJson(json: MerchantApiDto): Merchant {
		const branchesLastUpdateDate = json.branchesLastUpdateDate ? option(moment(json.branchesLastUpdateDate)) : none;
		return new Merchant(json.id, json.name, branchesLastUpdateDate);
	}

	toJson(): MerchantApiDto {
		const json: MerchantApiDto = {
			id: this.id,
			name: this.name,
			branchesLastUpdateDate: this.branchesLastUpdateDate.map(date => date.format()).orNull
		};
		return JsonConverter.removeEmptyFields(json);
	}

	copy({id = this.id, name = this.name, branchesLastUpdateDate = this.branchesLastUpdateDate}) {
		return new Merchant(id, name, branchesLastUpdateDate);
	}
}